import { connect } from 'react-redux';
import AppPageStep from '../components/AppPageStep';
import { getAppPageStep } from '../selectors';
import { addFutureChanged, changeAppSelection, changeAppSiteSelection, stepValidationStatusChanged } from '../actions';

const mapStateToProps = state => getAppPageStep(state);

const mapDispatchToProps = dispatch => ({
    onChangeAppSites: (ids, value) => dispatch(changeAppSiteSelection(ids, value)),
    onChangeApps: (ids, value) => dispatch(changeAppSelection(ids, value)),
    enableAddFutureAppSites: () => dispatch(addFutureChanged('app_site_id', true, true)),
    enableAddFutureApps: () => dispatch(addFutureChanged('app', true, true)),
    onStepValidationStatusChanged: status => dispatch(stepValidationStatusChanged(status)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { dimensionType } = stateProps;
    const isAppLevel = dimensionType === 'app';
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onChange: isAppLevel ? dispatchProps.onChangeApps : dispatchProps.onChangeAppSites,
        enableAddFuture: isAppLevel ? dispatchProps.enableAddFutureApps : dispatchProps.enableAddFutureAppSites,
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps, { forwardRef: true })(AppPageStep);
